import { Alert, AlertIcon, Spinner, Text } from "@chakra-ui/react";
import { translate } from "../../../i18n";
import { useListCoachs } from "../../coach-management/hooks/useListCoachs";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import CoachPricingManagementList from "./CoachPricingManagementList";

export default function CoachPricingManagementPage() {
    const { selectedOrganization } = useSelectedOrganization();
    const { data: coachs, isLoading, isError } = useListCoachs(selectedOrganization?.id);

    if (isLoading) return <Spinner />;

    if (isError) return <Alert status="error"><AlertIcon />{translate('error')}</Alert>;

    if (!coachs || coachs.length === 0) return <Text p={4}>{translate('no_data')}</Text>;

    return <CoachPricingManagementList coachs={coachs} />;
}
